import React from 'react';
import { AnimatedCounter } from './ui/AnimatedCounter';
export function StatsSection() {
  const stats = [{
    value: 12400,
    label: 'Games Tracked',
    suffix: '+'
  }, {
    value: 2.8,
    label: 'Reviews Aggregated',
    suffix: 'M+',
    decimals: 1
  }, {
    value: 340,
    label: 'Active Gamers',
    suffix: 'K+'
  }, {
    value: 156,
    label: 'Review Sources',
    suffix: ''
  }];
  return <section className="py-20 bg-pinnacle-card border-y border-pinnacle-border" data-id="element-185">
      <div className="container mx-auto px-4" data-id="element-186">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-187">
          {stats.map((stat, idx) => <div key={idx} className="p-4" data-id="element-188">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2 font-display" data-id="element-189">
                <AnimatedCounter end={stat.value} suffix={stat.suffix} decimals={stat.decimals} data-id="element-190" />
              </div>
              <div className="text-pinnacle-green uppercase tracking-wider text-sm font-semibold" data-id="element-191">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}